import React from 'react'
import AppStoreButtons from './app-store-buttons'

export const HaulerAppStoreButtons = ({ className = '' }) => {
  return (
    <AppStoreButtons
      className={className}
      googleLink="https://play.google.com/store/apps/details?id=com.totalmilk.haulerv15"
      iosLink="https://itunes.apple.com/us/app/total-milk-hauler/id1300097137?mt=8"
    />
  )
}
